var cov_1vw6zis4ib = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/dom/translate.ts",
      hash = "461d1b43026d13c51867dd513d429b1db2fb2019",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/dom/translate.ts",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 29
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 14
        },
        end: {
          line: 15,
          column: 35
        }
      },
      "2": {
        start: {
          line: 16,
          column: 17
        },
        end: {
          line: 16,
          column: 28
        }
      },
      "3": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 17,
          column: 50
        }
      },
      "4": {
        start: {
          line: 18,
          column: 12
        },
        end: {
          line: 18,
          column: 27
        }
      },
      "5": {
        start: {
          line: 19,
          column: 17
        },
        end: {
          line: 19,
          column: 53
        }
      },
      "6": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 15
        }
      },
      "7": {
        start: {
          line: 23,
          column: 38
        },
        end: {
          line: 23,
          column: 56
        }
      },
      "8": {
        start: {
          line: 24,
          column: 3
        },
        end: {
          line: 24,
          column: 79
        }
      },
      "9": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 42
        }
      },
      "10": {
        start: {
          line: 28,
          column: 27
        },
        end: {
          line: 28,
          column: 42
        }
      },
      "11": {
        start: {
          line: 29,
          column: 13
        },
        end: {
          line: 29,
          column: 31
        }
      },
      "12": {
        start: {
          line: 30,
          column: 13
        },
        end: {
          line: 30,
          column: 29
        }
      },
      "13": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 35,
          column: 3
        }
      },
      "14": {
        start: {
          line: 32,
          column: 5
        },
        end: {
          line: 32,
          column: 71
        }
      },
      "15": {
        start: {
          line: 34,
          column: 5
        },
        end: {
          line: 34,
          column: 67
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 29
          },
          end: {
            line: 14,
            column: 30
          }
        },
        loc: {
          start: {
            line: 14,
            column: 45
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "setTranslate",
        decl: {
          start: {
            line: 22,
            column: 16
          },
          end: {
            line: 22,
            column: 28
          }
        },
        loc: {
          start: {
            line: 22,
            column: 68
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 22
      },
      "2": {
        name: "setTranslate3D",
        decl: {
          start: {
            line: 27,
            column: 16
          },
          end: {
            line: 27,
            column: 30
          }
        },
        loc: {
          start: {
            line: 27,
            column: 70
          },
          end: {
            line: 36,
            column: 1
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 19,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 19,
            column: 35
          },
          end: {
            line: 19,
            column: 37
          }
        }, {
          start: {
            line: 19,
            column: 40
          },
          end: {
            line: 19,
            column: 41
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 42
          }
        }, {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 42
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }, {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }],
        line: 31
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { has3d, getTransformName } from './detect';
import { isRTL } from '../../config';
var use3d;
cov_1vw6zis4ib.s[0]++;
export var getDirectionX = function getDirectionX(xs) {
  cov_1vw6zis4ib.f[0]++;
  var num = (cov_1vw6zis4ib.s[1]++, Number.parseFloat(xs));
  var numStr = (cov_1vw6zis4ib.s[2]++, String(num));
  var start = (cov_1vw6zis4ib.s[3]++, xs.indexOf(numStr) + numStr.length);
  var u = (cov_1vw6zis4ib.s[4]++, xs.slice(start));
  var result = (cov_1vw6zis4ib.s[5]++, String((isRTL() ? (cov_1vw6zis4ib.b[0][0]++, -1) : (cov_1vw6zis4ib.b[0][1]++, 1)) * num) + u);
  cov_1vw6zis4ib.s[6]++;
  return result;
};
export function setTranslate(el, x, y) {
  cov_1vw6zis4ib.f[1]++;
  var tn = (cov_1vw6zis4ib.s[7]++, getTransformName());
  cov_1vw6zis4ib.s[8]++;
  el.style[tn] = "translate(".concat(getDirectionX(x), ",").concat(y, ")");
}
export function setTranslate3D(el, x, y) {
  cov_1vw6zis4ib.f[2]++;
  cov_1vw6zis4ib.s[9]++;

  if (use3d === undefined) {
    cov_1vw6zis4ib.b[1][0]++;
    cov_1vw6zis4ib.s[10]++;
    use3d = has3d();
  } else {
    cov_1vw6zis4ib.b[1][1]++;
  }

  var tn = (cov_1vw6zis4ib.s[11]++, getTransformName());
  var xd = (cov_1vw6zis4ib.s[12]++, getDirectionX(x));
  cov_1vw6zis4ib.s[13]++;

  if (use3d) {
    cov_1vw6zis4ib.b[2][0]++;
    ;
    cov_1vw6zis4ib.s[14]++;
    el.style[tn] = "translate3d(".concat(xd, ",").concat(y, ",0)");
  } else {
    cov_1vw6zis4ib.b[2][1]++;
    ;
    cov_1vw6zis4ib.s[15]++;
    el.style[tn] = "translate(".concat(xd, ",").concat(y, ")");
  }
}